import { render, staticRenderFns } from "./FgMeterHistoryData.vue?vue&type=template&id=5b2c78f8&"
import script from "./FgMeterHistoryData.vue?vue&type=script&lang=js&"
export * from "./FgMeterHistoryData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports